import { useEffect, useRef, type ReactNode } from 'react'
import { X } from 'lucide-react'

/** Modal usado para passos de confirmação (prévia da apuração) e pelo card do deal. */
export function CommissionDialog({
  children,
  label,
  title,
  description,
  onClose,
  busy = false,
  wide = false,
}: {
  children: ReactNode
  /** Nome acessível; vira o título visível quando `title` não é informado. */
  label: string
  title?: ReactNode
  description?: ReactNode
  onClose: () => void
  busy?: boolean
  wide?: boolean
}) {
  const ref = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const dialog = ref.current
    dialog?.showModal()
    // Foco inicial no primeiro controle do conteúdo, não no botão de fechar.
    const first = dialog?.querySelector<HTMLElement>(
      '.cc-dialog-body :is(input, select, textarea, button):not([disabled])',
    )
    ;(first ?? dialog)?.focus()
    return () => dialog?.close()
  }, [])
  return (
    <dialog
      ref={ref}
      className={`cc-dialog${wide ? ' cc-wide' : ''}`}
      aria-label={label}
      onCancel={(event) => {
        event.preventDefault()
        if (!busy) onClose()
      }}
    >
      <header className="cc-dialog-head">
        <div>
          <h2>{title ?? label}</h2>
          {description && <p className="cc-muted">{description}</p>}
        </div>
        <button
          type="button"
          className="cc-icon-button"
          aria-label="Fechar"
          onClick={onClose}
          disabled={busy}
        >
          <X size={16} aria-hidden="true" />
        </button>
      </header>
      <div className="cc-dialog-body">{children}</div>
    </dialog>
  )
}
